var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinIconSmal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 22.0002H9.5C4.5 22.0002 2.5 20.0002 2.5 15.0002V9.00024C2.5 4.00024 4.5 2.00024 9.5 2.00024H15.5C20.5 2.00024 22.5 4.00024 22.5 9.00024V15.0002C22.5 20.0002 20.5 22.0002 15.5 22.0002Z",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2145 10.4843H13.0715V11.4093C13.339 10.8773 14.025 10.3993 15.0555 10.3993C17.031 10.3993 17.5 11.4583 17.5 13.4013V16.9998H15.5V13.8438C15.5 12.7373 15.2325 12.1133 14.5515 12.1133C13.607 12.1133 13.2145 12.7858 13.2145 13.8433V16.9998H11.2145V10.4843V10.4843ZM7.785 16.9148H9.785V10.3993H7.785V16.9148V16.9148ZM10.0715 8.27476C10.0716 8.44239 10.0383 8.60837 9.97369 8.76305C9.90906 8.91773 9.81433 9.05801 9.695 9.17576C9.4532 9.41607 9.12591 9.55058 8.785 9.54976C8.44469 9.54953 8.11816 9.41536 7.876 9.17626C7.75711 9.05811 7.66269 8.91767 7.59817 8.76297C7.53365 8.60828 7.50029 8.44237 7.5 8.27476C7.5 7.93626 7.635 7.61226 7.8765 7.37326C8.11844 7.13384 8.44512 6.99961 8.7855 6.99976C9.1265 6.99976 9.4535 7.13426 9.695 7.37326C9.936 7.61226 10.0715 7.93626 10.0715 8.27476Z",
    fill: "#212121"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIconSmal);
export default __webpack_public_path__ + "static/media/linkedin-icon-smal.6f6f64609719014ea2087a247cb41528.svg";
export { ForwardRef as ReactComponent };